// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__S_syN","colBig":"styles_colBig__UMCPe","colSmall":"styles_colSmall__2wUVh"};